import { Flows } from "./ChattyFlow";
import { IntroFlow } from "./LandingPageChattyFlow";
import { getResultExt } from "./ChattyGetResult";

/*
const Landing2 = () => [
  {
    type: "comment",
    hint: [
      "Hello! Welcome to HeCafe!",
      "Aloha~~ Welcome to HeCafe!",
      "YoYoYo! Welcome to HeCafe!"
    ]
  },
  {
    type: "select",
    hint: ["Are you ready to go?", "Let's get started, how about that?"],
    choices: [{ label: "Sure!", value: "" }, { label: "Of cause!", value: "" }],
    extra: {
      type: "single-select"
    }
  },
  {
    type: "select",
    hint: ["Please input your gender!", "Please tell me your gender!"],
    choices: [{ label: "Boy", value: "boy" }, { label: "Girl", value: "girl" }],
    extra: {
      type: "single-select",
      id: "ask-gender"
    }
  }
];
*/

const getQuestions = path => {
  if (!Flows[`${decodeURIComponent(path)}`]) {
    // to handle if no chatty data of that url
    path = "/";
    let randIdx = Math.floor(Math.random() * Flows[`${path}`].length);
    return Flows[`${path}`][randIdx];
  }
  let randIdx = Math.floor(
    Math.random() * Flows[`${decodeURIComponent(path)}`].length
  );

  let baseQuestions = [];

  if (
    `${decodeURIComponent(path)}` === "/" ||
    `${decodeURIComponent(path)}` === "/aroma" ||
    `${decodeURIComponent(path)}` === "/roast"
  ) {
    baseQuestions = [...IntroFlow];
  }

  return [...baseQuestions, ...Flows[`${decodeURIComponent(path)}`][randIdx]];
};

const getResult = answers => {
  const lastAnswer = answers[answers.length - 1];

  // see questions in __tests__/ChattyGetResult.js
  if (typeof lastAnswer.question.results === "object") {
    return getResultExt(answers);
  }

  let question = lastAnswer.question;
  return question.extra.redirectUrl[lastAnswer.value];
};

export { getQuestions, getResult };
